<div *ngIf="!loading" class="row">
	<div class="col-md-12 button-close">
		<button [mat-dialog-close]="data" aria-label="Close" class="close" (click)="closeDialog()">
			<span aria-hidden="false">&times;</span>
		</button>
	</div>
</div>
<div class="row">
	<div class="col-md-12 featuredFlex">
		<img *ngIf="showErrorMsg" alt="..." class="errorMsgInfoIcon"
			 src="finance/payment-calculator/assets/image/i-ball.svg">
		<div class="erroMsgStyle" *ngIf="showErrorMsg">{{errorMsg}}</div>
	</div>
</div>
<div class="scroll">
	<div *ngIf="!loading" [formGroup]="paymentEstForm" class="tab--container">
		<mat-tab-group [(selectedIndex)]="selectedTab" ondragstart="return false" draggable="false"
					   (selectedTabChange)="onTabChange($event)">
			<mat-tab label="FINANCE">
				<div *ngIf="isFinanceDataExist; else notExist">
					<div class="row ">
						<div class="col-md-12 col-sm-12 col-12 topContainer">
							<div class=" col-md-6 occupyFullSpace priceWidth mobilePriceWidth ">
								<div class="subheaderstyle">ESTIMATED
									PRICE: {{sellingPrice | wholeDollar}}</div>
							</div>

							<div class="col-md-6 priceWidth mobilePriceWidth zipcodeAdjust zipcodeLabel">
								<div *ngIf="isShown" class="zipcode">Price based on ZIP code: {{zipCodeUpdate}} <a
									#zipCode (click)="loadZipcodeData()" class="zipCodePointer">CHANGE ZIP
									CODE</a></div>
								<div *ngIf="!isShown" class="zipCodeHtmlStyle">
									<form (ngSubmit)="updateZipCode()" [formGroup]="zipCodeForm" class="form-inline">
										<div class="form-group">
											<input class="form-control zipCodeTextStyle" formControlName="zipCodeInput"
												   type="text" numbersOnly maxlength="5">
										</div>
										<div class="form-group">
											<button class="btn zipCodeButton" type="submit"><span
												class="updateButtonLabel">UPDATE</span>
											</button>
										</div>
									</form>
								</div>
							</div>
							<div id="priceBorder" class="col-md-12 col-sm-12 col-12"></div>
						</div>
					</div>
					<div class="row scrollXdirection">
						<div class="col-md-12 flex">
							<div class="col-md-4 zoneone-Layout">
								<div class="row vehicleImageSpace">
									<div id="printVehicleInfo">
										<div class="row ">
											<div class="col-md-12 alignCenter">
												<img *ngIf="data.make==='Navigator'" [src]="vehicleImage" alt="..."
													 class="vehicle-image-navigator">
												<img *ngIf="data.make!=='Navigator'" [src]="vehicleImage" alt="..."
													 class="vehicle-image">

											</div>
										</div>
									</div>
								</div>

								<div class="row">

									<div class="col-md-12 featuredFlex">
										<div class="col-md-2 vehicleYearBlock vehicleYearLayout">
											<div class="vehicleyear">{{data.makeYear}}</div>
										</div>
										<div class="col-md-11">
											<div *ngIf="data.make==='Navigator'" class="vehiclemake">LINCOLN
												{{data.make}}</div>
											<div *ngIf="data.make!=='Navigator'" class="vehiclemake">LINCOLN
												{{data.make}}</div>

										</div>
									</div>
									<div class="col-md-12 vehicleModelspace">
										<div class="vehiclemodel">{{data.modelName}}</div>
									</div>

								</div>
								<div class="row">
									<div class="col-md-12 incentiveSpace">
										<div class="col-md-12">
											<div class="zoneOneLable">INCENTIVES

												<img #incentiveToolTip
													 class="tooltip-ibutton"
													 [ngbPopover]="popContent" placement="end"
													 [triggers]="calcPopoverTriggers"
													 autoClose=true
													 src="finance/payment-calculator/assets/image/tooltip.svg"
													 alt="...">
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="minus">-</div>
									<div *ngIf="totalIncentiveAmount!==0" class="col-md-11 incentiveLayout ">
										<div class="col-md-1" id="tick-mark"></div>
										<div class="col-md-10">
											<div
												class="incentiveText">{{totalIncentiveAmount | wholeDollar}}
												TOTAL </div>
										</div>
									</div>
									<div *ngIf="totalIncentiveAmount===0"
										 class="col-md-11 GrayincentiveLayout ">
										<div class="GrayincentiveText">NO AVAILABLE INCENTIVES </div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 tradeInDisplayFlex ">
										<div class="minusTradeIn">-</div>
										<div class=" col-md-6 TradeInmobileLayout">
											<div class="zoneOneLable">TRADE-IN</div>
											<input draggable="false" aria-label="finance-tradein" #tradeInValue
												   (click)="handleTradeInInputValueChange($event)"
												   (keydown)="adTradeInCurrency($event,tradeInValue)"
												   (blur)="downpaymentOnclick()"  class="tradeinText"
												   maxlength="8"
												   formControlName="tradeInValue" id="financeTradeIn" numbersOnly
												   type="text">
											<a class="estimate-trade-in-value c-p"
											   (click)="OpenEstimateTradeIn()"><span>Estimate Trade-in Value</span></a>
										</div>
										<div class="col-md-6 downpayMobLayout">
											<div class="zoneOneLable">DOWN-PAYMENT</div>
											<input #downPaymentValue
												   (keypress)="adDownPaymentCurrency($event,downPaymentValue)"
												   aria-label="finance-downpayment"
												   (click)="handleDownPaymentInputValueChange($event)"
												   (blur)="downpaymentOnclick()"
												   (keydown)="adDownPaymentCurrency($event,downPaymentValue)"
												   class="tradeinText" formControlName="downPaymentValue"
												   maxlength="8"
												   id="financeDownPayment" numbersOnly size="50" type="text">
											<div class="selling-price">{{(calcPercentage(downPaymentValue.value))}}%
												of Estimated Selling Price </div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 alignRight">
										<div class="col-md-12">
											<div class="zoneOneTotalPrice">TOTAL AMOUNT FINANCED:</div>
										</div>
									</div>
									<div class="col-md-12 alignRight ">
										<div class="col-md-12 occupyFullSpace">
											<div
												class="financepricing">{{totalAmountFinanced | wholeDollar}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-4 zonetwo-Layout">
								<div class="col-md-12 occupyFullSpace">
									<div class="zoneTwoLableAnnual">ANNUAL PERCENTAGE RATE</div>
								</div>
								<div class="col-md-12" style="display: grid;">
									<mat-radio-group (change)="onchangeRateType()" aria-label="Select an option"
													 class="special-rate" formControlName="rateType">
										<mat-radio-button *ngIf="renderSpecialRate" [checked]=isRadioType value="1">
											Special Rate
										</mat-radio-button>
										<mat-radio-button value="2">Enter Your Own
										</mat-radio-button>
									</mat-radio-group>
								</div>
								<div *ngIf="renderSpecialAprRate" class="row">
									<div class="col-md-12 aprBorderLine">
										<div class="col-md-10 occupyFullSpace">
											<img title="" src="finance/payment-calculator/assets/image/lincolnlogo.svg"
												 width="157px" alt="...">
										</div>
										<div class="col-md-12 occupyFullSpace">
											<div class="aprRateStyle">{{this.userRate}}% APR
												<img  alt="..." class="aprTooltip" 	 [ngbPopover]="popContent"
													  placement="auto"
													  [triggers]="calcPopoverTriggers"
													  autoClose=true
													 src="finance/payment-calculator/assets/image/tooltip.svg">
											</div>
										</div>
										<div class="col-md-9 occupyFullSpace">
											<div class="aprvalidatity">Rates are valid from {{aprStartDate}}
												to {{aprEndDate}}</div>
										</div>
									</div>
								</div>
								<div *ngIf="renderManualAprRate" class="row">
									<div class="col-md-12 useraprLayout">
										<div class="col-md-12">
											<div class="userApr">ENTER AN APR
												<img   ngbPopover="{{ToolTipConstants.MANUAL_APR_TOOLTIP}}"
													   placement="auto"
													   [triggers]="calcPopoverTriggers"
													   autoClose=true
													 class="blacklabeltooltip"
													 src="finance/payment-calculator/assets/image/iball-gray.svg"
													 alt="APR icon"/>
											</div>
										</div>
										<div class="col-md-7">
											<input userratevalidator #cursor (change)="formatManualApr()"
												   (keyup)="validateAprInput(cursor)" id="UserApr" #manualAprRate
												   maxlength="6" (keydown)="userAprRateChange()" class="manualApr "
												   formControlName="manualAprRate" type="text">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<div class="col-md-12 termSpacing occupyFullSpace">
											<div class="zoneTwoLableAnnual">TERM (IN MONTHS)</div>
										</div>
									</div>
								</div>
								<div class="grid-container">
									<div *ngFor="let term of financeTermsList" class="termBtn">
										<button class="termBtn"
												[style.background-color]="selectedTermValue === term ? '#324047' : '#EAEAEA'"
												[style.color]="selectedTermValue === term? '#FFFFFF' : ' #324047'"
												(click)="highlightTermSelection(term)">{{term}}</button>
									</div>
								</div>
							</div>
							<iframe title="Lets print" id="printFrame" style="width: 0; height: 0; border: 0"></iframe>


							<div class="col-md-4 ">
								<div class="zonethree-Layout" id="FinancesummaryContent">

									<div class="col-md-12 occupyFullSpace">
										<div class="zoneTwoLable" id="REVIEW FINANCING DETAILS">REVIEW FINANCING DETAILS</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">BASE MSRP
												<a 	 ngbPopover="{{ToolTipConstants.BASE_MSRP}}"
													   placement="auto"
													   [triggers]="calcPopoverTriggers"
													   autoClose=true
												   class="summary--disclosure" mat-raised-button data-container="body">
													<span class="summary--disclosure--size">1</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{data.BaseMsrp | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">TOTAL OPTIONS
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.OPTIONS}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">2</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{totalOption | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable" id="DESTINATION AND DELIVERY CHARGES">DESTINATION AND DELIVERY CHARGES
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.DND}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">3</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{parseNumber(dnd) | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">ESTIMATED SELLING PRICE
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.EST_SELLING_PRICE}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">4</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{sellingPrice | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">AVAILABLE INCENTIVES
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.AVAILABLE_INCENTIVES}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">5</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">-{{totalIncentiveAmount | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">ESTIMATED NET PRICE
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.EST_NET_PRICE}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">6</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{estimatedNetPrice | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">NET TRADE-IN VALUE
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.NET_TRADEIN}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">7</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">-{{tradeIn | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable" id="DOWN PAYMENT">DOWN PAYMENT
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.DOWNPAYMENT}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">8</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">-{{parseNumber(deposit) | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">AMOUNT FINANCED
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.AMOUNT_FINANCED}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">9</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{totalAmountFinanced | wholeDollar}}</div>
										</div>
									</div>

									<div class="col-md-12 vehicleyearBlock " id="printFinMonthlyPrice">
										<div class="col-md-12 solid3">
											<mat-spinner *ngIf="monthlyPaymentLoader" class="monthlyPaymentLoaderStyle">
											</mat-spinner>
											<div *ngIf="!monthlyPaymentLoader">
												<span
													class="monthlyPricelabel">{{this.monthlyPayment| wholeDollar}}</span><span class="perMonth">/MO</span>
												<a aria-label="Button that displays a tooltip in various positions"
												   class="monthlyPayDisclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.MONTHLY_PAYMENT}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="monthlypaymentDisclosureContent">10</span>
												</a>
												<div class="monthlypriceTerm">{{this.selectedTermValue}} MONTH
													TERM, {{this.userRate}}%
													APR </div>
											</div>
										</div>
									</div>
								</div>
								<div (click)="testDrive()" (keydown.enter)="testDrive()" class="col-md-12">
									<button class="btn testDriveButton" type="submit"><span
										class="testDriveButtonLabel updateButtonLabel">SCHEDULE A TEST DRIVE</span>
									</button>
								</div>
									<div class="col-md-12 col-sm-12 featuredFlex zonethreeaction">
										 <div id="downloadPdfDivFinance" (click)="printPDF()" (keydown.enter)="printPDF()"  class="alignFlex alignCenter">
											<div class="summaryActionLabel">DOWNLOAD</div>
										</div>
										<div id="applyOnlineDiv" (click)="applyOnline()" (keydown.enter)="applyOnline()" class="alignFlex alignCenter">
											<div class="applyOnlineStyle summaryActionLabel">APPLY ONLINE</div>
										</div>
									</div>
							</div>
						</div>
					</div>

				</div>
			</mat-tab>
			<mat-tab label="LEASE">
				<div *ngIf="isLeaseDataExist; else notExist">
					<div class="row ">
						<div class="col-md-12 col-sm-12 col-12 topContainer">
							<div class="col-md-6 occupyFullSpace priceWidth mobilePriceWidth ">
								<div class="subheaderstyle">ESTIMATED
									PRICE: {{sellingPrice+acquisitionFee| wholeDollar}}</div>

							</div>
							<div class="col-md-6  priceWidth mobilePriceWidth zipcodeAdjust zipcodeLabel">
								<div *ngIf="isShown" class="zipcode">Price based on ZIP code: {{zipCodeUpdate}} <a
									#zipCode (click)="loadZipcodeData()" class="zipCodePointer">CHANGE
									ZIP
									CODE</a></div>
								<div *ngIf="!isShown" class="zipCodeHtmlStyle">
									<form (ngSubmit)="updateZipCode()" [formGroup]="zipCodeForm" class="form-inline">
										<div class="form-group">
											<input class="form-control zipCodeTextStyle" formControlName="zipCodeInput"
												   type="text" numbersOnly maxlength="5">
										</div>
										<div class="form-group">
											<button class="btn zipCodeButton" type="submit"><span
												class="updateButtonLabel">UPDATE</span>
											</button>
										</div>
									</form>
								</div>
							</div>
							<div id="priceBorderLease" class="col-md-12 col-sm-12 col-12"></div>
						</div>
					</div>
					<div class="row ">
						<div class="col-md-12 col-sm-12 col-12 flex scrollXdirection">
							<div class="col-md-4 col-sm-12 col-12 zoneone-Layout">
								<div class="row vehicleImageSpace">
									<div id="printVehicleLeaseInfo">
										<div class="row">
											<div class="col-md-12 alignCenter">
												<img *ngIf="data.make==='Navigator'" [src]="vehicleImage" alt="..."
													 class="vehicle-image-navigator">
												<img *ngIf="data.make!=='Navigator'" [src]="vehicleImage" alt="..."
													 class="vehicle-image">
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 featuredFlex ">
										<div class="col-md-2 vehicleYearBlock vehicleYearLayout">
											<div class="vehicleyear">{{data.makeYear}}</div>
										</div>
										<div class="col-md-11">
											<div *ngIf="data.make==='Navigator'" class="vehiclemake">LINCOLN
												{{data.make}}</div>
											<div *ngIf="data.make!=='Navigator'" class="vehiclemake">LINCOLN
												{{data.make}}</div>
										</div>

									</div>

								</div>
								<div class="row">
									<div class="col-md-12 vehicleModelspace">
										<div class="vehiclemodel">{{data.modelName}}</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 incentiveSpace">
										<div class="col-md-12">
											<span class="zoneOneLable">INCENTIVES</span>
											<img #leaseIncentiveToolTip [ngbPopover]="popContent"
												 placement="end"
												 [triggers]="calcPopoverTriggers"
												 autoClose=true
												 src="finance/payment-calculator/assets/image/tooltip.svg" alt="...">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="minus">-</div>
									<div *ngIf="totalIncentiveAmount!==0" class="col-md-11 incentiveLayout ">
										<div class="col-md-1 " id="tick-markLease"></div>
										<div class="col-md-10">
											<div
												class="incentiveText">{{totalIncentiveAmount | wholeDollar}}
												TOTAL </div>
										</div>
									</div>
									<div *ngIf="totalIncentiveAmount===0"
										 class="col-md-11 GrayincentiveLayout ">
										<div class="GrayincentiveText">NO AVAILABLE INCENTIVES </div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 tradeInDisplayFlex">
										<div class="minusTradeIn">-</div>
										<div class=" col-md-6 TradeInmobileLayout">
											<div class="zoneOneLable">TRADE-IN</div>
											<input #leaseTradeInValue (click)="handleTradeInInputValueChange($event)"
												   (keydown)="handleTradeInInputValueChange($event)"
												   (keypress)="adTradeInCurrency($event,leaseTradeInValue)"
												   (keyup)="adTradeInCurrency($event,leaseTradeInValue)"
												   maxlength="8"
												   class="tradeinText" formControlName="tradeInValue" id="leaseTradeIn"
												   numbersOnly type=" text">
											<a class="estimate-trade-in-value c-p"
											   (click)="OpenEstimateTradeIn()"><span>Estimate Trade-in Value</span></a>
										</div>
										<div class="col-md-6 downpayMobLayout">
											<div class="zoneOneLable">DOWN-PAYMENT</div>
											<input #leaseDownPaymentValue
												   (click)="handleDownPaymentInputValueChange($event)"
												   (keydown)="handleDownPaymentInputValueChange($event)"
												   (change)="downpaymentOnclick()"
												   (keypress)="adDownPaymentCurrency($event,leaseDownPaymentValue)"
												   (keyup)="adDownPaymentCurrency($event,leaseDownPaymentValue)"
												   maxlength="8"
												   class="tradeinText" formControlName="downPaymentValue"
												   id="leaseDownPayment" numbersOnly size="50" type="text">
											<div
												class="selling-price">{{(calcPercentage(leaseDownPaymentValue.value))}}%
												of Estimated Capitalized Cost </div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12 alignRight">

										<div class="zoneOneadjustedprice">ADJUSTED CAPATILIZED COST:</div>
									</div>
									<div class="col-md-12 alignRight ">
										<div class="col-md-12 occupyFullSpace">
											<div
												class="financepricing">{{totalAmountFinanced | wholeDollar}}
											</div>
										</div>
									</div>
								</div>
								<iframe title="Lets print" id="printLeaseFrame"
										style="width: 0; height: 0; border: 0"></iframe>
							</div>

							<div class="col-md-4 col-sm-12 col-12 zonetwo-Layout">
								<div class="col-md-12 occupyFullSpace">
									<div class="zoneTwoLableAnnual">ANNUAL MILES</div>
								</div>
								<div class="row">
									<div class="col-md-12 ">
										<div class="col-md-7">
											<select #annualMiles (change)="annualMileChangeListener()"
													[value]="annualMileValue" class="annualMiles"
													formControlName="annualMiles" matNativeControl required>
												<option *ngFor="let mileage of annualMileageList" [value]="mileage">
													{{mileage.toLocaleString()}}</option>
											</select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<div class="col-md-12 termSpacing occupyFullSpace">
											<div class="zoneTwoLableAnnual">TERM (IN MONTHS)</div>
										</div>
									</div>
								</div>
								<div class="grid-container">
									<div *ngFor="let term of leaseTermsList" class="termBtn">
										<button class="termBtn"
												[style.background-color]="selectedTermValue === term ? '#324047' : '#EAEAEA'"
												(click)="highlightTermSelection(term)"
												[style.color]="selectedTermValue === term? '#FFFFFF' : ' #324047'">{{term}}</button>
									</div>
								</div>
							</div>
							<div class="col-md-4">
								<div class="zonethree-Layout" id="LeasesummaryContent">
									<div class="col-md-12 occupyFullSpace">
										<div class="zoneTwoLable">REVIEW FINANCING DETAILS</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">BASE MSRP
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.BASE_MSRP}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
												<span class="summary--disclosure--size">1</span>
												</a>
										</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{data.BaseMsrp | wholeDollar}}</div>

										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable" id="TOTAL OPTIONS">TOTAL OPTIONS
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button ngbPopover="{{ToolTipConstants.OPTIONS}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">2</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{totalOption | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">DESTINATION AND DELIVERY CHARGES
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button ngbPopover="{{ToolTipConstants.DND}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">3</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{parseNumber(dnd) | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">ACQUISITION FEE
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button ngbPopover="{{ToolTipConstants.ACQUISITION_FEE}}"
												   placement="auto"
												   [triggers]="calcPopoverTriggers"
												   autoClose=true>
													<span class="summary--disclosure--size">11</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{acquisitionFee | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">ESTIMATED CAPATILIZED COST
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.EST_CAPITALIZED_COST}}"
												   placement="auto"   [triggers]="calcPopoverTriggers">
													<span class="summary--disclosure--size">4</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{sellingPrice+acquisitionFee | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">DOWN PAYMENT
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button  ngbPopover="{{ToolTipConstants.DOWNPAYMENT}}"
												   placement="auto"   [triggers]="calcPopoverTriggers">
													<span class="summary--disclosure--size">8</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">-{{parseNumber(deposit) | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable" id="NET TRADE-IN VALUE">NET TRADE-IN VALUE
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button ngbPopover="{{ToolTipConstants.NET_TRADEIN}}"
												   placement="auto"   [triggers]="calcPopoverTriggers">
													<span class="summary--disclosure--size">7</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">-{{tradeIn | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">AVAILABLE INCENTIVES
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.AVAILABLE_INCENTIVES}}"
												   placement="auto"   [triggers]="calcPopoverTriggers">
													<span class="summary--disclosure--size">5</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">-{{totalIncentiveAmount | wholeDollar}}</div>
										</div>
									</div>


									<div class="col-md-12 featuredFlex zonethreeLabelGap">
										<div class="col-md-9 ">
											<div class="zoneThreeLable">ADJUSTED CAPATILIZED COST
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.ADJ_CAPITALIZED_COST}}"
												   placement="auto"   [triggers]="calcPopoverTriggers">
													<span class="summary--disclosure--size">12</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{totalAmountFinanced | wholeDollar}}</div>
										</div>
									</div>
									<div class="col-md-12 featuredFlex">
										<div class="col-md-9">
											<div class="zoneThreeLable">ESTIMATED CASH DUE AT LEASE SIGNING
												<a aria-label="Button that displays a tooltip in various positions"
												   class="summary--disclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.EST_CASH_DUE}}"
												   placement="auto"   [triggers]="calcPopoverTriggers">
													<span class="summary--disclosure--size">13</span>
												</a>
											</div>
										</div>
										<div class="col-md-3">
											<div
												class="zoneThreeLable">{{leaseSigningAmount | wholeDollar}}</div>
										</div>
									</div>
									<div id="printLeaseMonthlyPrice" class="col-md-12 vehicleyearBlock">
										<div class="col-md-12 solid3">
											<mat-spinner *ngIf="monthlyPaymentLoader" class="monthlyPaymentLoaderStyle">
											</mat-spinner>
											<div *ngIf="!monthlyPaymentLoader">
												<span
													class="monthlyPricelabel">{{this.monthlyPayment| wholeDollar}}</span>
												<span class="perMonth">/MO

												</span>
												<a aria-label="Button that displays a tooltip in various positions"
												   class="monthlyPayDisclosure" mat-raised-button
												   ngbPopover="{{ToolTipConstants.MONTHLY_PAYMENT_LEASE}}"
												   placement="auto"  [triggers]="calcPopoverTriggers">
													<span class="monthlypaymentDisclosureContent">10</span>
												</a>
												<div class="monthlypriceTerm">{{this.selectedTermValue}} MONTH
													LEASE, {{this.annualMileage}} MILES </div>
											</div>
										</div>
									</div>
								</div>
								<div (click)="testDrive()" (keydown.enter)="testDrive()" class="col-md-12">
									<button class="btn testDriveButton" type="submit"><span
										class="testDriveButtonLabel updateButtonLabel">SCHEDULE A TEST DRIVE</span>
									</button>
								</div>

								<div class="col-md-12 col-sm-12 featuredFlex zonethreeaction">
									<div id="downloadPdfDivLease" (click)="printPDF()" (keydown.enter)="printPDF()" class=" alignFlex alignCenter">
										<div class="summaryActionLabel">DOWNLOAD</div>
									</div>
									<div (click)="applyOnline()" (keydown.enter)="applyOnline()" class="alignFlex alignCenter">
										<div class="applyOnlineStyle summaryActionLabel">APPLY ONLINE</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>
			</mat-tab>
			<ng-template #notExist>
				<div class="row">
					<div class="col-md-12">
						<img [src]="vehicleImage" alt="..." class="vehicle-image--incentive--not--exist">
						<div class="error--incentive--not--exist">
							<div class="lincoln--incentive--not--exist">
								<span class="normal--style">{{data.makeYear}}</span>
								<span style="padding-right: 10px;">LINCOLN</span>
								<span>{{data.make}}</span>
								<div class="slice--incentive--not--exist">
									{{data.modelName}}
								</div>
							</div>
							<div class="lease-estimate-not-a">
								<div class="please-contact-your">
									<span *ngIf="!isFinanceDataExist; else leaseEstimateMessage">
										Please contact your dealer or make a different selection to see finance
										estimation.
									</span>
									<ng-template #leaseEstimateMessage>
										We do not have any special lease incentives at this time in your ZIP Code, so we
										are
										unable to calculate a lease payment. Please contact your local dealer to
										determine
										estimated lease payments.
									</ng-template>
								</div>
								<button class="btn contactButton" type="submit" (click)="testDrive()"><span
									class="testDriveButtonLabel updateButtonLabel">CONTACT DEALER</span>
								</button>
							</div>

						</div>
					</div>
				</div>
			</ng-template>
		</mat-tab-group>
		<div>
			<div class="row">
				<div class="col-md-12 featuredFlex">
					<div (click)="openDisclosurePanel()" (keydown.enter)="openDisclosurePanel()" class="disclosureLabel">ADDITIONAL INFORMATION &
						DISCLOSURES</div>
					<span (click)="openDisclosurePanel()" (keydown.enter)="openDisclosurePanel()" class="glyphiconRight glyphicon-menu-right"></span>
				</div>

			</div>

		</div>

		<div *ngIf="isDisclosureOpen==='open'" class="row disclosureLayout">
			<div class="col-md-12">
				<div class="disclosureContent">
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					CONSULT YOUR DEALER FOR ACTUAL PRICE, PAYMENTS, QUALIFICATIONS AND COMPLETE DETAILS.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					This payment estimator is a tool to help you estimate your monthly payments and does not make any
					representation as to actual payment amounts. The payments calculated using this tool are ESTIMATES
					ONLY.
					The information that you enter to use this payment estimator tool are for your estimation and
					comparison
					purposes only. ACTUAL PRICES AND PAYMENTS MAY BE DIFFERENT due to local rebates, specials, fees and
					credit qualifications.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					1. The Base Manufacturer's Suggested Retail Price (MSRP) is the price of the vehicle without the
					Documentation Fee, Destination / Delivery charge, Taxes, Title and Registration or Optional
					Equipment. The MSRP is the vehicle price as recommended by the “manufacturer” often called the
					‘sticker’ or list price. Images shown may not necessarily represent the options selected on any
					vehicle.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					2. Total of Options: Option pricing is based on MSRP.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					3. Charges associated with getting the vehicle from the manufacturer to the dealership.
				</div>
			</div>
			<div class="col-md-12">

				<div class="disclosureContent">
					4. The Estimated Selling Price/Estimated Capitalized Cost shown is the Base MSRP plus destination
					charges and total of options, but does not include service contracts, insurance or any outstanding
					prior credit balance. Does not include Tax, Title or Registration Fees.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					5. Incentives are available at the time of posting and are subject to change and expiration. Not all
					incentives can be redeemed together. Restrictions may apply. See your local dealer for complete
					details.
				</div>
			</div>
			<div class="col-md-12">

				<div class="disclosureContent">
					6. Estimated Net Price is equal to the Estimated Selling Price of the vehicle less Available
					Incentives.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					7. The difference between the estimated value and any amount still owing on your trade-in vehicle.
					The "Trade-In Value" of your vehicle is an estimate, only, and many factors that cannot be assessed
					without a physical inspection of the vehicle may affect actual value. For purposes of this website,
					we use the services of a third-party vendor to provide Trade-In Value calculations. While we believe
					this information is reliable, we are not responsible for and do not guarantee the accuracy or
					reliability of the information. Please see your local dealer for information regarding actual
					trade-in availability and value. </div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					8. Down Payment: The cash amount paid towards the total down payment for the transaction. </div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					9. Amount Financed is the amount used to determine the Monthly Payment. It is equal to the Estimated
					Net Price of the vehicle less Net Trade-in Value and Down Payment.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					10. Payments calculated using this tool are ESTIMATES ONLY. ACTUAL PRICES AND PAYMENTS MAY BE
					DIFFERENT. Financing payment calculations are based on APR and term. NOT ALL BUYERS WILL QUALIFY FOR
					THE LOWEST LINCOLN AUTOMOTIVE FINANCIAL SERVICES APR. Lease payment calculations are based on term
					and annual mileage. NOT ALL LESSEES WILL QUALIFY FOR THE LOWEST RED CARPET LEASE PAYMENT. Lease
					payment based on Lincoln Automotive Financial Services Red Carpet lease. Lessee has the option to
					purchase the vehicle upon lease termination at a price negotiated with dealer at lease signing or
					inception. Lessee is responsible for Excess Wear and Use and for Mileage over the “miles per term
					allowance” as stated below:<br>
					$0.15 per mile for vehicles with Base MSRPs up to $30,000<br>
					$0.20 per mile for vehicles with Base MSRPs from $30,001 to $49,999<br>
					$0.25 per mile for vehicles with Base MSRPs over $50,000<br>
					NOT ALL COMMERCIALEASE LESSEES WILL QUALIFY FOR LINCOLN AUTOMOTIVE FINANCIAL SERVICES COMMERCIALEASE
					FINANCING. See dealer for qualification and complete details.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					11. A charge paid by the lessee to Lincoln Automotive Financial Services to help cover the cost of
					acquiring and servicing the account.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					12. Estimated Adjusted Capitalized Cost is the amount used to determine the Estimated Monthly
					Payment. It is equal to the Estimated Capitalized Cost less Down Payment, Available Incentives, and
					Net Trade-in Amount.
				</div>
			</div>
			<div class="col-md-12">
				<div class="disclosureContent">
					13. The amount to be paid by the lessee prior to or at the signing of the lease or by the delivery
					of the vehicle. The amount due at signing is after application of all available incentives and
					rebates. It includes the first month’s payment and any Down Payment/Estimated Net Trade-In Amount.
				</div>
			</div>
		</div>
	</div>
</div>
<mat-spinner class="loaderStyle" *ngIf="loading"></mat-spinner>

<ng-template #popContent>
	<div  [innerHtml]=this.incentiveInfo></div>
</ng-template>
